import { DateTime } from 'luxon';

/**
 * Checks whether the supplied date is today. Does not work if times are involved.
 */
export const isToday = (date?: DateTime) => {
  return date?.toISODate() === DateTime.local().toISODate();
};

/**
 * Returns a date object based on the time between now and the supplied date.
 */
export const dateDifferenceFromNow = (date?: DateTime) => {
  if (!date) return {};

  return date
    .diff(DateTime.now(), ['years', 'months', 'days', 'hours'])
    .toObject();
};

/**
 * Calculate age from a date of birth in "DD/MM/YYYY" format.
 */
export const calculateAgeFromDOB = (dobString: string): number => {
  const [day, month, year] = dobString?.split('/');

  const dob = DateTime.fromObject({
    day: parseInt(day),
    month: parseInt(month),
    year: parseInt(year),
  });

  const currentDateTime = DateTime.now();
  const age = currentDateTime.diff(dob, 'years').years;

  return Math.floor(age);
};

export const formatDate = (dateString: string) => {
  if (!dateString) return '';
  const [year, month, day] = dateString?.split('-');
  return `${day}/${month}/${year}`;
};
